'use client';

import { motion } from 'motion/react';

interface TourWelcomePromptProps {
  onStart: () => void;
  onSkip: () => void;
}

export function TourWelcomePrompt({ onStart, onSkip }: TourWelcomePromptProps) {
  return (
    <div className='fixed inset-0 z-[200] flex items-center justify-center bg-black/60 p-6'>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.25 }}
        className='flex w-full max-w-sm flex-col gap-5 rounded-xl border bg-background p-6 shadow-2xl'
      >
        <div className='space-y-1.5'>
          <h2 className='text-base font-semibold'>Welcome to NxCut</h2>
          <p className='text-sm leading-relaxed text-muted-foreground'>
            Take a quick tour to learn the key features and get up and running fast.
          </p>
        </div>
        <div className='flex flex-col gap-2.5'>
          <button
            onClick={onStart}
            className='w-full rounded-lg bg-blue-500 py-2.5 text-sm font-medium text-white transition-opacity hover:opacity-80'
          >
            Start Tour
          </button>
          <button
            onClick={onSkip}
            className='w-full rounded-lg py-2.5 text-sm text-muted-foreground transition-colors hover:bg-muted'
          >
            Skip
          </button>
        </div>
      </motion.div>
    </div>
  );
}
